import React, {useState} from 'react';
import {FormGroup, Input, Label} from 'reactstrap';
import {randomDataSources, TemplateKind, WizardField} from './vibe.ts';

interface WizardInputProps {
    label: string;
    name: WizardField;
    value: string;
    kind: TemplateKind;
    placeholder?: string;
    onChange: (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    onSuggestionClick: (name: WizardField, value: string) => void;
    isTextarea?: boolean;
    rows?: number;
}

const CHIP_CAP = 6;

const WizardFieldComponent: React.FC<WizardInputProps> = ({
    label,
    name,
    value,
    kind,
    placeholder,
    onChange,
    onSuggestionClick,
    isTextarea = false,
    rows = 2
}) => {
    const suggestions = randomDataSources[kind][name];
    const [expanded, setExpanded] = useState(false);

    const visibleSuggestions = expanded
        ? suggestions
        : suggestions.slice(0, CHIP_CAP);
    const hiddenCount = suggestions.length - visibleSuggestions.length;

    return (
        <FormGroup>
            <Label for={`wizard-${name}`}>{label}</Label>
            <Input
                type={isTextarea ? 'textarea' : 'text'}
                name={name}
                id={`wizard-${name}`}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                rows={isTextarea ? rows : undefined}
                bsSize="sm"
            />
            {suggestions.length > 0 && (
                <div className="vibe-ideas">
                    <span className="vibe-ideas__label">Ideas:</span>
                    <div className="vibe-ideas__chips">
                        {visibleSuggestions.map(suggestion => (
                            <button
                                type="button"
                                key={suggestion}
                                className="vibe-chip"
                                onClick={() =>
                                    onSuggestionClick(name, suggestion)
                                }
                                title={`Use: "${suggestion}"`}
                            >
                                {suggestion}
                            </button>
                        ))}
                        {hiddenCount > 0 && (
                            <button
                                type="button"
                                className="vibe-chip vibe-chip--more"
                                onClick={() => setExpanded(true)}
                            >
                                +{hiddenCount} more
                            </button>
                        )}
                    </div>
                </div>
            )}
        </FormGroup>
    );
};

export default WizardFieldComponent;
